var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.haveVettingBookingRequest
    ? _c("div", [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container-fluid" },
          [
            _c(
              "booking-form",
              {
                attrs: {
                  "property-mutator": _vm.setVettingRequestProperty,
                  booking: _vm.booking,
                  validationTriggered: _vm.validationTriggered,
                },
              },
              [
                _c("vetting-edit-shortlist", {
                  attrs: { slot: "shortlist" },
                  slot: "shortlist",
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "dashboard-block" },
              [
                _c(
                  "ladda-button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { click: _vm.handleSaveVettingRequestCallback },
                  },
                  [_vm._v("\n        Save Pending Request\n      ")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dashboard-page-title" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("h1", [_vm._v("Edit Pending Request")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }